module.exports = __webpack_public_path__ + "img/American_Credit_Business_Loans_Tax_Benefits.ff75304.png";